/**
 * FIDE rating tables (Rating Regulations B.02, applied 1 March 2024):
 * table 8.1.1 (fractional score p -> rating difference dp) and table 8.1.2
 * (rating difference D -> expected score PD of the higher-rated player).
 */

/** dp for p = 1.00, 0.99, ..., 0.50 (index = 100 - round(100p)). */
const DP_HIGH = [
  800, 677, 589, 538, 501, 470, 444, 422, 401, 383, 366, 351, 336, 322, 309, 296, 284, 273, 262,
  251, 240, 230, 220, 211, 202, 193, 184, 175, 166, 158, 149, 141, 133, 125, 117, 110, 102, 95, 87,
  80, 72, 65, 57, 50, 43, 36, 29, 21, 14, 7, 0,
];

/** Table 8.1.1: dp for a fractional score p (rounded to two decimals). */
export function dpFromFraction(p: number): number {
  const pc = Math.round(Math.min(1, Math.max(0, p)) * 100);
  if (pc >= 50) return DP_HIGH[100 - pc] as number;
  return -(DP_HIGH[pc] as number);
}

/** Upper bounds of D for PD = .50, .51, ... .99 (table 8.1.2); above 735 PD = 1.0. */
const PD_BOUNDS = [
  3, 10, 17, 25, 32, 39, 46, 53, 61, 68, 76, 83, 91, 98, 106, 113, 121, 129, 137, 145, 153, 162,
  170, 179, 188, 197, 206, 215, 225, 235, 245, 256, 267, 278, 290, 302, 315, 328, 344, 357, 374,
  391, 411, 432, 456, 484, 517, 559, 619, 735,
];

/** Table 8.1.2: expected score for a rating difference D (own minus opponent's). */
export function expectedFromDifference(d: number): number {
  const a = Math.abs(Math.round(d));
  let pd = 1;
  for (let i = 0; i < PD_BOUNDS.length; i++) {
    if (a <= (PD_BOUNDS[i] as number)) {
      pd = 0.5 + i / 100;
      break;
    }
  }
  return d >= 0 ? pd : 1 - pd;
}
